import { solid } from "@fortawesome/fontawesome-svg-core/import.macro";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useMemo, useState } from "react";

export interface CardItemProps {
  item: {
    id: number;
    name: string;
    price: number;
    quantity: number;
    discount: number;
  };
}

export const CardItem = ({ item }: CardItemProps) => {
  const [itemQuantity, setItemQuantity] = useState(item.quantity);
  const [itemPrice] = useState(item.price);
  const [itemDiscount] = useState(item.discount);
  const [itemTotal, setItemTotal] = useState(item.price * item.quantity);

  const cartDetail = useMemo(() => {
    return {
      itemQuantity,
      itemPrice,
      itemDiscount,
      itemTotal,
    };
  }, [itemQuantity, itemPrice, itemDiscount, itemTotal]);

  const adjustQuantity = (amount: number) => {
    setItemQuantity((currentQuuantity) => {
      currentQuuantity = currentQuuantity + amount;

      setItemTotal((currentTotal) => {
        return currentTotal + amount * item.price;
      });

      if (currentQuuantity >= 10) {
        return 10;
      } else if (currentQuuantity <= 0) {
        return 0;
      } else {
        return currentQuuantity;
      }
    });
  };

  const handleQuantityChange = (
    event?: React.ChangeEvent<HTMLInputElement>
  ) => {
    console.log("event", event);
    console.log("event.target.value", event?.target.value);
  };

  useEffect(() => {
    console.log("cartDetail", cartDetail);
    handleQuantityChange();
  }, [cartDetail]);

  return (
    <div className="flex items-stretch bg-teal-100 p-2 mb-2 rounded-md shadow-md text-sm">
      <div className="flex-2">
        <img
          className="block object-cover object-center h-24 w-24 rounded-md"
          src="https://picsum.photos/200/300"
          alt="random"
        />
      </div>
      <div className="grow ml-2 self-center">
        <h4>{item.name}</h4>
        <h4 className="font-semibold mb-2">
          ${item.price.toFixed(2)}
          {item.discount > 0 && (
            <>
              <del className="text-gray-500 font-normal ml-1">
                ${(item.price * item.discount) / 100}
              </del>
              <span className="text-red-500 ml-1">{item.discount}%</span>
            </>
          )}
        </h4>
        <div className="inline-flex bg-white rounded-md border p-1">
          <FontAwesomeIcon
            icon={solid("minus")}
            className="text-1xl pt-2 mb-2 block has-badge w-6"
            onClick={() => adjustQuantity(-1)}
          />
          <input
            className="text-center w-10"
            type="number"
            value={itemQuantity}
            min="0"
            max="10"
            onChange={handleQuantityChange}
          />
          <FontAwesomeIcon
            icon={solid("plus")}
            className="text-1xl pt-2 mb-2 block has-badge w-6"
            onClick={() => adjustQuantity(1)}
          />
        </div>
      </div>
    </div>
  );
};
